









































import mixins from 'vue-typed-mixins';
import SurveyUtils, {
  Survey,
  Question,
  Page,
  Section,
} from '@/utils/SurveyUtils';
import SurveyLayoutSection from './layout/SurveyLayoutSection.vue';
import SectionLayoutModal from './layout/SectionLayoutModal.vue';
import cloneDeep from 'lodash.clonedeep';
import LayoutUtils from './layout/LayoutUtils';
export default mixins().extend({
  components: {
    SurveyLayoutSection,
    SectionLayoutModal,
  },

  props: {
    value: {
      type: Object as () => Survey,
    },
  },

  data(): {
    questions?: Question[];
    modal: {
      mode?: 'create' | 'edit';
      pristine?: Partial<Page | Section>;
      parent?: Partial<Page | Section>;
    };
  } {
    return {
      questions: undefined,
      modal: {
        mode: undefined,
        pristine: undefined,
        parent: undefined,
      },
    };
  },

  async mounted() {
    this.$loading(true);
    try {
      const resp = await Promise.all([
        SurveyUtils.api.question.list({ surveyid: this.value.id }),
      ]);

      this.questions = resp[0];

      // recursivly loop through layout structure and merge questions with found values from API
      // also remove the found questions from the questions list so there are no duplicate questions
      const recursiveQuestionFormatter = (items: Partial<Section | Page>[]) => {
        if (this.questions) {
          for (let i = 0; i < items.length; i++) {
            if (items[i].type === 'section') {
              const section = items[i] as Section;
              recursiveQuestionFormatter(section.children);
            } else if (items[i].type === 'page') {
              const page = items[i] as Page;
              for (let j = 0; j < page.questions.length; j++) {
                const index = this.questions?.findIndex(
                  (val) => val.id === page.questions[j].id
                );
                if (index >= 0) {
                  page.questions[j] = this.questions[index];
                  this.questions.splice(index, 1);
                } else {
                  delete page.questions[j]; // if question not found there is an issue and it must be removed
                }
              }

              // only allow questions that were found to be on layout
              page.questions = page.questions.filter((question) => !!question);
            }
          }
        }
      };
      recursiveQuestionFormatter(this.value.layout);

      this.$emit('pristine', this.value); // update the pristine value on the view so that it doesn't trigger navigation blocks
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
    this.$loading(false);
  },
  methods: {
    create(parent?: Partial<Page | Section>) {
      this.modal = {
        mode: 'create',
        pristine: undefined,
        parent: parent,
      };
    },

    edit(item: Partial<Page | Section>) {
      this.modal = {
        mode: 'edit',
        pristine: item,
        parent: undefined,
      };
    },

    async remove(item: Partial<Page | Section>) {
      await this.$confirm(
        this.$i18n
          .t('validation.confirmation.delete', [
            this.$translate(
              item.type === 'section'
                ? (item as Section).title
                : (item as Page).shortname
            ),
          ])
          .toString(),
        async () => {
          const recursive = (list: any[]) => {
            const index = list.findIndex((val) => val === item);
            if (index >= 0) {
              const recursiveQuestionSearch = (item: any) => {
                // find questions that exist on pages before remove to add them to the question list
                if (item.questions) {
                  this.questions = this.questions?.concat(item.questions);
                } else if (item.children && item.children.length > 0) {
                  for (let i = 0; i < item.children.length; i++) {
                    recursiveQuestionSearch(item.children[i]);
                  }
                }
              };
              recursiveQuestionSearch(list[index]);
              list.splice(index, 1);
            } else {
              for (let i = 0; i < list.length; i++) {
                if (list[i].children && list[i].children.length > 0) {
                  recursive(list[i].children);
                }
              }
            }
          };
          recursive(this.value.layout);
        }
      );
    },

    submit(value: Partial<Section | Page>) {
      if (this.modal.mode === 'edit') {
        Object.assign(this.modal.pristine, value);
      } else if (this.modal.mode === 'create' && value) {
        if (this.modal.parent) {
          (this.modal.parent as Section)?.children?.push(value);
        } else {
          this.value.layout.push(value);
        }
      }
      this.modal.mode = undefined;
      this.modal.pristine = undefined;
      this.modal.parent = undefined;
    },

    validateMove(evt: any) {
      return LayoutUtils.validateMove(evt);
    },
  },
});
